import Game from './game';

const GAINED_SECONDS = 2.5;

const YELLOW_LIMIT = 20;

const RED_LIMIT = 10;

export default class Timer {
    #initialTimeInSeconds; // added to properly calculate timer's blue bar width;

    #timeInSeconds;

    #currentTimeInSeconds;

    #intervalInstance;

    #timeoutInstance;

    start(timeInSeconds) {
        this.#timeInSeconds = timeInSeconds;
        this.#initialTimeInSeconds = timeInSeconds;
        this.#currentTimeInSeconds = timeInSeconds;
        this.refresh();
        this.#intervalInstance = setInterval(() => {
            this.#currentTimeInSeconds--;
            this.updateTimer();
        }, 1000);
        // separated the "setTimeout" function so that it can be called in 2 places, here and in "updateTimer()";
        this.setCountdownTimer();
    }

    stop() {
        clearTimeout(this.#timeoutInstance);
        clearInterval(this.#intervalInstance);
    }

    pauseOnBlur() {
        if (!Game.levelIsRunning) return;
        clearTimeout(this.#timeoutInstance);
        clearInterval(this.#intervalInstance);
        this.#timeInSeconds = this.#currentTimeInSeconds;
    }

    resumeOnFocus() {
        if (!Game.levelIsRunning) return;
        this.#intervalInstance = setInterval(() => {
            this.#currentTimeInSeconds--;
            this.updateTimer();
        }, 1000);
        this.setCountdownTimer();
    }

    refresh() {
        $('.timer-bar .timer').css('width', '100%');
        $('.timer-bar .timer')
            .removeClass('yellow-timer red-timer')
            .addClass('blue-timer');
    }

    updateTimer(gainedSeconds) {
        // "gainedSeconds" parameter is only available when user catches "clock" item. So when it's available
        //update the timer bar;
        if (gainedSeconds) {
            // if adding number of seconds to current exceeds maximum seconds allowed per level
            this.#currentTimeInSeconds + GAINED_SECONDS >
            this.#initialTimeInSeconds
                ? // then make it maximum;
                  (this.#currentTimeInSeconds = this.#initialTimeInSeconds)
                : // else add number of seconds to current time;
                  (this.#currentTimeInSeconds += GAINED_SECONDS);
            this.#timeInSeconds = this.#currentTimeInSeconds;
            // update countdown of timer bar;
            this.setCountdownTimer();
        }

        let width =
            (this.#currentTimeInSeconds / this.#initialTimeInSeconds) * 100;
        $('.timer-bar .timer').css('width', width + '%');
        if (width < RED_LIMIT) {
            $('.timer-bar .timer')
                .removeClass('blue-timer yellow-timer')
                .addClass('red-timer');
        } else if (width < YELLOW_LIMIT) {
            $('.timer-bar .timer')
                .removeClass('blue-timer red-timer')
                .addClass('yellow-timer');
        }
    }

    getCurrentSeconds() {
        return this.#currentTimeInSeconds;
    }

    setCountdownTimer() {
        clearTimeout(this.#timeoutInstance);
        this.#timeoutInstance = setTimeout(() => {
            clearInterval(this.#intervalInstance);
            if (Game.currentScore > Game.highScore) {
                Game.showHighScoreScreen();
                window.localStorage.setItem('high_score', Game.currentScore);
            } else {
                Game.showBadLuckScreen();
            }
        }, this.#timeInSeconds * 1000);
    }
}
